import { useEffect, useRef } from 'react';
import { toast } from '@/components/ui/sonner';
import { isDesktopApp, isDesktopOffline } from '@/api/desktopSync';
import { captureAssetTransport } from '@/api/assetTransport';
import useDesktopScope from './useDesktopScope';

export function useAssetUpdateNotice({ fetchUpdateStatus, decide, notify, deps = [] }) {
  const scope = useDesktopScope();
  const options = useRef(null); options.current = { fetchUpdateStatus, decide, notify };
  useEffect(() => {
    let active = true; let toastId; let timer; let retire;
    const current = () => active && scope.current() && scope.admin && isDesktopApp() && !isDesktopOffline();
    async function check() {
      if (!current()) return;
      try {
        const value = await Promise.race([options.current.fetchUpdateStatus(captureAssetTransport(scope)),
          new Promise((_, reject) => { retire = () => reject(new Error('Notice unavailable')); timer = setTimeout(retire, 30000); })]);
        if (!current()) return;
        const decision = options.current.decide(value);
        if (!decision) return;
        toastId = options.current.notify({ decision, updateStatus: value, publishedVersion: value?.published?.version, current });
      } catch { /* Optional checking never invalidates installed data. */ }
      finally { clearTimeout(timer); }
    }
    check();
    return () => { active = false; retire?.(); clearTimeout(timer); if (toastId != null) toast.dismiss?.(toastId); };
    // Domain callbacks use the current captured scope; their caller supplies navigation dependencies.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scope, ...deps]);
}
export default useAssetUpdateNotice;
